import { useSelector } from 'react-redux';
import { RootState } from 'store/types';

export const usePremiumOffer = () => {
  return useSelector((state: RootState) => state.cycle.premiumOffers);
};
